import { Injectable, signal } from '@angular/core';

@Injectable()
export class SupplierPromotionQueryService {
  showAll = signal(false);
}
